import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { ResizeHandleComponent } from './resize-handle.component';
import { ResizeLeftDirective } from './resize-left.directive';
import { ResizeRightDirective } from './resize-right.directive';



@NgModule({
  declarations: [ResizeHandleComponent, ResizeLeftDirective, ResizeRightDirective],
  imports: [
    SharedModule
  ],
  exports : [
    ResizeHandleComponent, ResizeLeftDirective, ResizeRightDirective
  ]
})
export class ResizeHandleModule { }
